import React from 'react';
import AgreementModal from './AgreementModal';
interface IAgreementModalProps {
  openAgreementModal: () => void;
  closeAgreementModal: () => void;
  acceptAgreement: (pdfBlob: any) => void;
  declineAgreement: () => void;
  openAgreement: boolean,
  details: any

}
const AgreementComponent: React.FC<IAgreementModalProps> = (props: any) => {

  const handleCloseModal = () => {
    props?.closeAgreementModal()
  };

  const handleConfirm = (pdfBlob: any) => {
    props?.acceptAgreement(pdfBlob)
    props?.closeAgreementModal()
  };

  const handleDecline = () => {
    props?.declineAgreement()
    props?.closeAgreementModal()
  };

  return (
    <div>
      {/* <button onClick={handleOpenModal}>Show Agreement</button> */}

      <AgreementModal
        isOpen={props?.openAgreement}
        onConfirm={handleConfirm}
        onDecline={handleDecline}
        onRequestClose={handleCloseModal}
        details={props?.details || {
          email: "",
          firstName: "",
          lastName: "",
          school: "this.props.school?.name"
        }}
      />
    </div>
  );
};

export default AgreementComponent;



// WEBPACK FOOTER //
// ./src/components/agreementModal/index.tsx